{
  "chat.greeting": "¡Hola! Soy Clari, tu asistente virtual de 3DICOM.",
  "chat.lastConversation": "Estoy aquí para ayudarte a navegar por la plataforma 3DICOM, desde cargar y compartir estudios, explorarlos en el visor o entender las opciones de almacenamiento.",
  "chat.helpPrompt": "¿Qué te gustaría hacer o sobre qué quieres saber más?",
  "widget.title": "3DICOM - Chatea con nosotros",
  "widget.disclaimer": "<p>No ingrese información de salud protegida. Este chatbot no debe usarse para diagnóstico o tratamiento. Las respuestas de IA pueden contener errores.</p><p>Al usar este chatbot, acepta sus <a rel=\"noopener noreferrer nofollow\" class=\"text-primary underline cursor-pointer\" href=\"https://3dicomviewer.com/chatbot-terms-of-use/\" target=\"_blank\">Términos de uso</a>.</p>",
  "widget.menu.newChat": "Iniciar nuevo chat",
  "widget.menu.endChat": "Finalizar chat",
  "widget.menu.recentChats": "Ver chats recientes"
}
